/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Row, Col, Card, Container, ListGroup, Media, ButtonGroup } from 'react-bootstrap'
import ToggleButton from 'react-bootstrap/ToggleButton'

import { Cookies } from "react-cookie"
// import manage_user from '../images/ic_manage_user.svg'
// import SearchIcon from '@material-ui/icons/Search';

import { authSign, reqAddUserToGroup, reqSerchUserByText } from '../service'

// import ic_role_manage from '../images/ic_role_manage.svg'
import ic_checked from '../images/ic_checked.svg'
import Swal from 'sweetalert2'

//const cookies = new Cookies()

const AddMemberToRole = (props) => {
    const { users } = props.data;
    const [usersSearch, setUsersSearch] = useState([])
    const [textSearch, settextSearch] = useState("")
    const [checked, setChecked] = useState(users);

    useEffect(() => {
        RequestSerchUserByText(textSearch)
    }, [users]);


    const handleChangeCheck = (value) => {
        // var check = false
        const checkedTemp = [...checked]
        const new_user = {
            "id": usersSearch[value].id,
            "idp": usersSearch[value].id,
            "firstname": usersSearch[value].first_name,
            "lastname": usersSearch[value].last_name,
            "picture": usersSearch[value].image_url,
            "employeeid": usersSearch[value].ref_id,
        }
        const isLargeNumber = (element) => element.employeeid === new_user.employeeid
        var index = checkedTemp.findIndex(isLargeNumber)
        if (index < 0) {
            checkedTemp.push(new_user)
            if (props.data.groupID === undefined) {
                setChecked(checkedTemp)
            } else {
                const data = {
                    group_id: props.data.groupID,
                    user: new_user
                }
                reqAddUserToGroup(data).then(res => {
                    // console.log(res)
                    Swal.fire({
                        icon: 'success',
                        title: "Add successfully",
                    })
                    props.addUser()
                }).catch(err => {
                    console.log(err)
                })
            }
        } else {
            removeAllElements(checkedTemp, new_user);
            setChecked(checkedTemp)
        }
        props.handleChange(data => ({ ...data, users: checkedTemp }));
    }
    function removeAllElements(array, elem) {
        const isLargeNumber = (element) => element.employeeid === elem.employeeid
        var index = array.findIndex(isLargeNumber)
        // var index = array.indexOf(elem);
        console.log(index)
        if (index > -1) {
            array.splice(index, 1);
        }
        console.log(array)
    }
    const handleChange = (event) => {
        settextSearch(event.target.value)
        console.log(event.target.value)
        if (event.target.value.length > 3) {
            RequestSerchUserByText(event.target.value)
        }

    };

    if (props.currentStep !== 2) {
        return null
    }




    function RequestSerchUserByText(text) {
        authSign().then(res => {
            if (res.token !== undefined) {
                const cookies = new Cookies()
                cookies.set('token', res.token)
                cookies.set('tmp', res.tmp)
                const params = {
                    "work": "SEARCH_USERS_BY_TEXT",
                    "item_per_request": 50,
                    "current_item_amount": 0,
                    "search_value": text
                }
                reqSerchUserByText(params).then(res => {
                    // console.log(res)
                    setUsersSearch(res.result)
                }).catch(err => {
                    console.log(err)
                })
            }
        }).catch(err => {
            console.log(err)
        })
    }
    return (
        <Container role="main" className="main-content bg-whiht">
            <div className='row flex-xl-nowrap'>
                <div className='col-md-12'>
                    <div className='flex-column align-items-center justify-content-between'>
                        {/* <Button onClick={handleClickBack} variant="link" className="mt-3 p-0">
                            <p className="text-muted" style={{ fontSize: "14px" }} >
                                <Icon style={{ paddingTop: "6px" }}>keyboard_arrow_left</Icon>Home</p>
                        </Button>
                        <h4 className="mb-4">Edit Role</h4> */}
                        {props.previousButton()}
                    </div>
                </div>
            </div>
            <Row>
                <Col xs={8}>
                    <Card className="shadow-sm">
                        <Card.Header as="h5" className="bg-white border-0">
                            <div className="d-flex bd-highlight mt-3">
                                <div className="flex-grow-1 bd-highlight">
                                    <div className="input-group mb-2">
                                        {/* <div className="input-group-prepend">
                                            <div className="input-group-text bg-white"><SearchIcon></SearchIcon></div>
                                        </div> */}
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="inlineFormInputGroup"
                                            placeholder="Search"
                                            style={{ "border": "1px solid #ced4da" }}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            {/* <h6>A</h6> */}
                            <ListGroup variant="flush">
                                {
                                    usersSearch.length > 0 ?
                                        usersSearch.map((user, i) => {
                                            return (
                                                (users.filter(function (e) {
                                                    return e.employeeid === user.ref_id;;
                                                }).length) ? ('') : <ListGroup.Item key={user.id} className='custom-item' >
                                                    <Media className="float-left">
                                                        {/* <img
                                                                width={40}
                                                                height={40}
                                                                className="mr-3 rounded-circle"
                                                                src="data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2264%22%20height%3D%2264%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2064%2064%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_1773dcd93e1%20text%20%7B%20fill%3A%23999%3Bfont-weight%3Anormal%3Bfont-family%3A-apple-system%2CBlinkMacSystemFont%2C%26quot%3BSegoe%20UI%26quot%3B%2CRoboto%2C%26quot%3BHelvetica%20Neue%26quot%3B%2CArial%2C%26quot%3BNoto%20Sans%26quot%3B%2C%26quot%3BLiberation%20Sans%26quot%3B%2Csans-serif%2C%26quot%3BApple%20Color%20Emoji%26quot%3B%2C%26quot%3BSegoe%20UI%20Emoji%26quot%3B%2C%26quot%3BSegoe%20UI%20Symbol%26quot%3B%2C%26quot%3BNoto%20Color%20Emoji%26quot%3B%2C%20monospace%3Bfont-size%3A10pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_1773dcd93e1%22%3E%3Crect%20width%3D%2264%22%20height%3D%2264%22%20fill%3D%22%23373940%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%2214.5625%22%20y%3D%2237.1%22%3E64x64%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E"
                                                                alt="Generic placeholder"
                                                            /> */}
                                                        <Media.Body>
                                                            <p>{user.first_name}  {user.last_name}, {user.ref_id}</p>
                                                            <p></p>
                                                        </Media.Body>
                                                    </Media>
                                                    <ButtonGroup style={{ width: 55 }} toggle className="mb-2 float-right">
                                                        <ToggleButton
                                                            type="checkbox"
                                                            variant="light"
                                                            checked={
                                                                users.filter(function (e) {
                                                                    return e.employeeid === user.ref_id;;
                                                                })
                                                            }
                                                            value={i}
                                                            onChange={(e) => handleChangeCheck(e.currentTarget.value)}
                                                        >
                                                            {(users.filter(function (e) {
                                                                return e.employeeid === user.ref_id;;
                                                            }).length) ? (<img src={ic_checked} alt='' />) : 'Add'}

                                                        </ToggleButton>

                                                    </ButtonGroup>
                                                    {/* <Button variant="light" className="float-right text-dark border">Add</Button> */}
                                                </ListGroup.Item>

                                            )
                                        })
                                        : null
                                }
                            </ListGroup>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={4}></Col>
            </Row>
        </Container>
    )

    // return (
    //     <div className="d-flex justify-content-center">
    //         <div className="p-2 col-md-10">
    //             {/* <h2 className="float-left">Dashboard</h2> */}
    //             {props.previousButton()}
    //             <blockquote className="blockquote">
    //                 <h4 className="mb-0">Role Detail</h4>
    //             </blockquote>
    //             <Row>
    //                 <Col xs={8}>
    // <Card>
    //     <Card.Header as="h5" className="bg-white">
    //         <div className="d-flex bd-highlight mt-3">
    //             <div className="flex-grow-1 bd-highlight">
    //                 <div className="input-group mb-2">
    //                     <div className="input-group-prepend">
    //                         <div className="input-group-text bg-white"><SearchIcon></SearchIcon></div>
    //                     </div>
    //                     <input
    //                         type="text"
    //                         className="form-control"
    //                         id="inlineFormInputGroup"
    //                         placeholder="search"
    //                         style={{ "border": "1px solid #ced4da" }}
    //                         onChange={handleChange}
    //                     />
    //                 </div>
    //             </div>
    //         </div>
    //     </Card.Header>
    //     <Card.Body>
    //         {/* <h6>A</h6> */}
    //         <ListGroup variant="flush">
    //             {
    //                 usersSearch.length > 0 ?
    //                     usersSearch.map((user, i) => {
    //                         return (
    //                             (users.filter(function (e) {
    //                                 return e.employeeid === user.ref_id;;
    //                             }).length) ? ('') : <ListGroup.Item key={user.id}>
    //                                 <Media className="float-left">
    //                                     {/* <img
    //                                         width={40}
    //                                         height={40}
    //                                         className="mr-3 rounded-circle"
    //                                         src="data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2264%22%20height%3D%2264%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2064%2064%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_1773dcd93e1%20text%20%7B%20fill%3A%23999%3Bfont-weight%3Anormal%3Bfont-family%3A-apple-system%2CBlinkMacSystemFont%2C%26quot%3BSegoe%20UI%26quot%3B%2CRoboto%2C%26quot%3BHelvetica%20Neue%26quot%3B%2CArial%2C%26quot%3BNoto%20Sans%26quot%3B%2C%26quot%3BLiberation%20Sans%26quot%3B%2Csans-serif%2C%26quot%3BApple%20Color%20Emoji%26quot%3B%2C%26quot%3BSegoe%20UI%20Emoji%26quot%3B%2C%26quot%3BSegoe%20UI%20Symbol%26quot%3B%2C%26quot%3BNoto%20Color%20Emoji%26quot%3B%2C%20monospace%3Bfont-size%3A10pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_1773dcd93e1%22%3E%3Crect%20width%3D%2264%22%20height%3D%2264%22%20fill%3D%22%23373940%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%2214.5625%22%20y%3D%2237.1%22%3E64x64%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E"
    //                                         alt="Generic placeholder"
    //                                     /> */}
    //                                     <Media.Body>
    //                                         <p>{user.first_name}  {user.last_name}, {user.ref_id}</p>
    //                                         <p></p>
    //                                     </Media.Body>
    //                                 </Media>
    //                                 <ButtonGroup style={{ width: 55 }} toggle className="mb-2 float-right">
    //                                     <ToggleButton
    //                                         type="checkbox"
    //                                         variant="light"
    //                                         checked={
    //                                             users.filter(function (e) {
    //                                                 return e.employeeid === user.ref_id;;
    //                                             })
    //                                         }
    //                                         value={i}
    //                                         onChange={(e) => handleChangeCheck(e.currentTarget.value)}
    //                                     >
    //                                         {(users.filter(function (e) {
    //                                             return e.employeeid === user.ref_id;;
    //                                         }).length) ? (<img src={ic_checked} alt='' />) : 'Add'}

    //                                     </ToggleButton>

    //                                 </ButtonGroup>
    //                                 {/* <Button variant="light" className="float-right text-dark border">Add</Button> */}
    //                             </ListGroup.Item>

    //                         )
    //                     })
    //                     : null
    //             }
    //         </ListGroup>
    //     </Card.Body>
    //                         <Card.Footer className="text-muted bg-white"> <img src={manage_user} alt="" className="mr-2" />{checked.length} Members</Card.Footer>
    //                     </Card>
    //                 </Col>
    //                 <Col xs={4}>
    //                     <Card className="border-0">
    //                         <Card.Header as="h5" className="bg-white"><img src={ic_role_manage} alt="" width="20" className="mr-2" /> Role Name {roleName}</Card.Header>
    //                         <Card.Body>
    //                             <p className="mb-2">Service</p>
    //                             {
    //                                 apps.map((app, i) => {
    //                                     return (
    //                                         <div key={i} className="clearfix border-bottom my-1">
    //                                             <h6 className="float-left">{(app.route) ? app.route.name : ''}</h6>
    //                                             <p className="mb-2 float-right">{(app.permission) ? app.permission.name : ''}</p>
    //                                         </div>
    //                                     )
    //                                 })
    //                             }
    //                             {/* <Button variant="outline-light" className="text-dark border">Add/Edit Service</Button> */}
    //                         </Card.Body>
    //                     </Card>
    //                 </Col>
    //             </Row>
    //         </div>
    //     </div>
    // )
}

export default AddMemberToRole